@if (isNavigating()) {
  <div class="flex flex-col items-center justify-center gap-6 py-24">
    <div
      class="h-16 w-16 animate-spin rounded-full border-4 border-t-transparent"
      [ngStyle]="{
        borderColor: corporateDesign.primaryColor(),
        borderTopColor: 'transparent',
      }"></div>
    <p
      class="text-xl font-semibold"
      [ngStyle]="{ color: corporateDesign.primaryColor() }">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.checkingVehicleLoading
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </p>
  </div>
} @else if (isLoading() || !availabilityStore.hasResult()) {
  <div class="flex flex-col items-center justify-center gap-6 py-24">
    <div
      class="h-16 w-16 animate-spin rounded-full border-4 border-t-transparent"
      [ngStyle]="{
        borderColor: corporateDesign.primaryColor(),
        borderTopColor: 'transparent',
      }"></div>
    <p
      class="text-xl font-semibold"
      [ngStyle]="{ color: corporateDesign.primaryColor() }">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.onDemandRequestingLoading
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </p>
  </div>
} @else if (!isAvailable()) {
  <div
    class="flex flex-col items-center gap-4 rounded-2xl border p-8 text-center"
    [ngStyle]="{ borderColor: corporateDesign.primaryBorderColor() }">
    <span
      class="material-symbols-rounded text-5xl"
      [ngStyle]="{
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().colorAdmixtures.error_red_dark
          : corporateDesign.corporateDesign().colorAdmixtures.error_red,
      }"
      >warning</span
    >
    <p
      class="text-xl font-semibold"
      [ngStyle]="{
        color: corporateDesign.isDarkModeActive()
          ? corporateDesign.corporateDesign().primaryDarkFontColor
          : corporateDesign.corporateDesign().primaryFontColor,
      }">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.noConnectionAvailable
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </p>
    @if (rejectionReason()) {
      <p class="text-sm opacity-70">{{ rejectionReason() }}</p>
    }
  </div>
} @else {
  <div class="flex flex-col items-stretch gap-6 md:flex-row">
    <div class="w-full md:w-2/3">
      <div
        class="flex flex-col gap-4 rounded-2xl border p-8"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.surface1(),
          color: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().primaryDarkFontColor
            : corporateDesign.corporateDesign().colorAdmixtures
                .standard_text_high,
        }">
        @if (connectionOptions().length > 1) {
          <h2 class="text-2xl font-bold">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.chooseConnection
                  : EEntityType.onDemandTicketConfiguration
                | language
            }}
          </h2>
          <div
            class="mb-4 flex flex-col gap-3 rounded-xl border p-5"
            [ngStyle]="{ borderColor: corporateDesign.primaryBorderColor() }">
            <span class="text-base font-medium">{{
              textStore.texts()
                | filterTexts
                  : ERelationType.availableDepartures
                  : EEntityType.onDemandTicketConfiguration
                | language
            }}</span>
            <div class="flex flex-wrap gap-2">
              @for (
                option of connectionOptions();
                track option
              ) {
                <button
                  type="button"
                  class="rounded-xl border px-4 py-2 text-base font-medium transition-colors"
                  [ngStyle]="
                    selectionState.selectedConnectionOption() === option
                      ? {
                          backgroundColor: corporateDesign.primaryColor(),
                          color:
                            corporateDesign.corporateDesign()
                              .primaryDarkFontColor,
                          borderColor: corporateDesign.primaryColor(),
                        }
                      : {
                          backgroundColor: 'transparent',
                          color: 'inherit',
                          borderColor: corporateDesign.primaryBorderColor(),
                        }
                  "
                  (click)="selectionState.selectConnectionOption(option)">
                  {{ option.departureTimetabled | date: 'HH:mm' }} Uhr
                </button>
              }
            </div>
          </div>
        }

        <h2 class="text-2xl font-bold">
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.furtherDetails
                : EEntityType.onDemandTicketConfiguration
              | language
          }}
        </h2>

        @for (
          passengerForm of passengerForms;
          track $index;
          let pIdx = $index
        ) {
          <div
            class="flex flex-col gap-6 rounded-xl border p-5"
            [ngStyle]="{ borderColor: corporateDesign.primaryBorderColor() }">
            <div [formGroup]="passengerForm" class="flex flex-col gap-6">
              <div class="flex items-center justify-between gap-3">
                <h3 class="text-xl font-semibold">
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.onDemandPassenger
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                  {{ pIdx + 1 }}
                </h3>
                @if (pIdx > 0) {
                  <button
                    type="button"
                    [attr.data-testid]="'remove-passenger-' + pIdx"
                    (click)="removePassenger(pIdx)"
                    class="flex h-12 w-12 items-center justify-center rounded-xl border"
                    [ngStyle]="{
                      borderColor: corporateDesign.isDarkModeActive()
                        ? corporateDesign.corporateDesign().colorAdmixtures
                            .error_red_dark
                        : corporateDesign.corporateDesign().colorAdmixtures
                            .error_red,
                      color: corporateDesign.isDarkModeActive()
                        ? corporateDesign.corporateDesign().colorAdmixtures
                            .error_red_dark
                        : corporateDesign.corporateDesign().colorAdmixtures
                            .error_red,
                    }">
                    <span class="material-symbols-rounded">delete</span>
                  </button>
                }
              </div>

              @if (showExistingTicketDropdown()) {
                <aw-drop-down
                  [id]="'existing-ticket-' + pIdx"
                  [label]="
                    textStore.texts()
                      | filterTexts
                        : ERelationType.existingTicket
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  "
                  formControlName="existingTicketType"
                  [options]="existingTicketOptions()"
                  name="name"
                  valueAttribute="name" />
              }

              @if (passengerForm.controls.useExistingTicket.value) {
                <div
                  class="mt-1 rounded-xl border p-4 text-sm"
                  [ngStyle]="{
                    borderColor:
                      corporateDesign.corporateDesign().secondaryBorderColor,
                    backgroundColor: corporateDesign.isDarkModeActive()
                      ? corporateDesign.corporateDesign().colorAdmixtures
                          .dark_surface_02
                      : corporateDesign.corporateDesign().secondaryColor
                        ? corporateDesign.corporateDesign().secondaryColor +
                          '20'
                        : corporateDesign.corporateDesign().colorAdmixtures
                            .standard_text_divider,
                    color: corporateDesign.isDarkModeActive()
                      ? corporateDesign.corporateDesign().secondaryColor
                      : corporateDesign.primaryFontColor(),
                  }">
                  <span class="mb-1 flex items-center gap-1 font-bold">
                    <span class="material-symbols-rounded text-lg">info</span>
                    {{
                      textStore.texts()
                        | filterTexts
                          : ERelationType.onDemandExistingTicketHintHeadline
                          : EEntityType.onDemandTicketConfiguration
                        | language
                    }}
                  </span>
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.onDemandExistingTicketHint
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                </div>
              }

              @if (
                showFahrgasttyp() &&
                !passengerForm.controls.useExistingTicket.value
              ) {
                <div class="flex flex-col gap-2">
                  <span class="text-base font-medium">{{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.passengerType
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}</span>
                  <div
                    class="flex flex-row overflow-hidden rounded-xl border"
                    [ngStyle]="{
                      borderColor: corporateDesign.primaryBorderColor(),
                    }">
                    @for (option of fahrgasttypOptions(); track option) {
                      <button
                        type="button"
                        class="inline-flex flex-1 items-center justify-center px-4 py-3 text-base font-medium transition-colors"
                        [ngStyle]="
                          passengerForm.controls.fahrgasttyp.value === option
                            ? {
                                backgroundColor: corporateDesign.primaryColor(),
                                color:
                                  corporateDesign.corporateDesign()
                                    .primaryDarkFontColor,
                              }
                            : {
                                backgroundColor: 'transparent',
                                color: 'inherit',
                              }
                        "
                        (click)="
                          passengerForm.controls.fahrgasttyp.setValue(option)
                        ">
                        @if (
                          passengerForm.controls.fahrgasttyp.value === option
                        ) {
                          <span
                            class="material-symbols-rounded mr-1 text-base"
                            aria-hidden="true">
                            check
                          </span>
                        }
                        {{ option }}
                      </button>
                    }
                  </div>
                </div>
              }
            </div>

            @if (bookableServiceOptions().length > 0) {
              <div class="flex flex-col gap-3">
                @for (
                  extra of passengerForm.controls.selectedExtras.controls;
                  track $index;
                  let eIdx = $index
                ) {
                  <div
                    [formGroup]="extra"
                    class="flex flex-row items-center gap-3">
                    <aw-drop-down
                      class="flex-1"
                      [id]="'extra-select-' + pIdx + '-' + eIdx"
                      [label]="
                        (textStore.texts()
                          | filterTexts
                            : ERelationType.onDemandExtra
                            : EEntityType.onDemandTicketConfiguration
                          | language) +
                        ' ' +
                        (eIdx + 1)
                      "
                      formControlName="publicTransportXml"
                      [options]="getAvailableBookableServiceOptions(pIdx, eIdx)"
                      name="label"
                      valueAttribute="mobilityUserField" />
                    <button
                      type="button"
                      [attr.data-testid]="'remove-extra-' + eIdx"
                      (click)="removeExtra(passengerForm, eIdx)"
                      class="flex h-12 w-12 items-center justify-center rounded-xl border"
                      [ngStyle]="{
                        borderColor: corporateDesign.isDarkModeActive()
                          ? corporateDesign.corporateDesign().colorAdmixtures
                              .error_red_dark
                          : corporateDesign.corporateDesign().colorAdmixtures
                              .error_red,
                        color: corporateDesign.isDarkModeActive()
                          ? corporateDesign.corporateDesign().colorAdmixtures
                              .error_red_dark
                          : corporateDesign.corporateDesign().colorAdmixtures
                              .error_red,
                      }">
                      <span class="material-symbols-rounded">delete</span>
                    </button>
                  </div>
                }

                <button
                  type="button"
                  [attr.data-testid]="'add-extra-btn-' + pIdx"
                  (click)="addExtra(passengerForm)"
                  class="flex w-full items-center justify-center gap-2 rounded-xl border py-3 text-base font-medium"
                  [ngStyle]="{
                    color: corporateDesign.primaryColor(),
                    borderColor: corporateDesign.primaryColor(),
                  }">
                  <span class="material-symbols-rounded">add</span>
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.addExtra
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                </button>
              </div>
            }
          </div>
        }

        <button
          type="button"
          id="add-passenger-btn"
          (click)="addPassenger()"
          class="flex w-full items-center justify-center gap-2 rounded-xl border p-4 text-base font-semibold"
          [ngStyle]="{
            borderColor: corporateDesign.primaryColor(),
            color: corporateDesign.primaryColor(),
            backgroundColor: corporateDesign.primaryColor() + '10',
          }">
          <span class="material-symbols-rounded">add</span>
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.addPassenger
                : EEntityType.onDemandTicketConfiguration
              | language
          }}
        </button>
      </div>
    </div>

    <div class="w-full md:w-1/3">
      @if (trip()) {
        <div class="flex flex-col">
          <div
            class="flex flex-col gap-5 rounded-t-2xl border-t border-r border-l p-8"
            [ngStyle]="{
              borderColor: corporateDesign.primaryBorderColor(),
              backgroundColor: corporateDesign.surface1(),
              color: corporateDesign.isDarkModeActive()
                ? corporateDesign.corporateDesign().primaryDarkFontColor
                : corporateDesign.corporateDesign().colorAdmixtures
                    .standard_text_high,
            }">
            <h2 class="text-3xl leading-tight font-bold">
              {{
                textStore.texts()
                  | filterTexts
                    : ERelationType.combination
                    : EEntityType.onDemandTicketConfiguration
                  | language
              }}
            </h2>

            <div class="flex flex-row items-center gap-2 text-base opacity-70">
              <span
                >{{
                  textStore.texts()
                    | filterTexts
                      : ERelationType.onDemandTripDate
                      : EEntityType.onDemandTicketConfiguration
                    | language
                }}
                {{
                  tripDate() | date: dateFormatSupport.activeDateFormat()
                }}</span
              >
            </div>

            <div class="flex flex-col">
              @for (leg of trip().legs; track $index; let legIndex = $index) {
                <div class="relative flex min-h-30 flex-row gap-3">
                  <div class="relative flex w-5 shrink-0 flex-col items-center">
                    <div
                      class="relative z-10 h-7 w-7 rounded-full border-3"
                      [ngStyle]="{
                        borderColor: corporateDesign.primaryColor(),
                        backgroundColor: corporateDesign.surface1(),
                      }"></div>
                    <div
                      class="absolute bottom-0"
                      [class.w-1]="!isTransferLeg(leg)"
                      [class.border-l-2]="isTransferLeg(leg)"
                      [class.border-dashed]="isTransferLeg(leg)"
                      style="top: 20px"
                      [ngStyle]="{
                        backgroundColor: isTransferLeg(leg)
                          ? 'transparent'
                          : availabilityStore.isOnDemandLeg(leg)
                            ? corporateDesign.primaryColor()
                            : corporateDesign.primaryBorderColor(),
                        borderColor: isTransferLeg(leg)
                          ? corporateDesign.primaryBorderColor()
                          : 'transparent',
                      }"></div>
                  </div>
                  <div class="relative flex flex-1 flex-col gap-1.5 pb-6">
                    <div class="flex flex-row items-baseline gap-2">
                      <span class="mr-4 ml-2 text-base font-bold">{{
                        getDisplayDeparture(leg, trip().legs[legIndex - 1])
                      }}</span>
                      <span class="mb-6 text-base font-medium">{{
                        leg.origin.name
                      }}</span>
                    </div>
                    @if (isTransferLeg(leg)) {
                      <span
                        class="absolute w-fit -translate-y-1/2 text-sm font-medium whitespace-nowrap opacity-60"
                        style="top: calc(50% + 0.875rem)">
                        {{
                          getTransferLabel(
                            leg,
                            trip().legs[legIndex + 1],
                            getTransferDepartureTime(trip().legs[legIndex + 1]),
                            getTransferArrivalTime(trip().legs[legIndex - 1])
                          )
                        }}
                      </span>
                    } @else if (availabilityStore.isOnDemandLeg(leg)) {
                      <span
                        class="absolute left-18.5 w-fit -translate-y-1/2 rounded-xl px-3 py-2 text-sm font-semibold whitespace-nowrap"
                        style="top: calc(50% + 0.875rem)"
                        [ngStyle]="{
                          backgroundColor: corporateDesign.primaryColor(),
                          color:
                            corporateDesign.corporateDesign()
                              .primaryDarkFontColor,
                        }">
                        {{
                          getTransportName(leg, matchedMapping()?.name ?? 'AST')
                        }}
                      </span>
                    } @else {
                      <span
                        class="absolute left-18.5 w-fit -translate-y-1/2 rounded-xl border px-3 py-2 text-sm font-semibold whitespace-nowrap"
                        style="top: calc(50% + 0.875rem)"
                        [ngStyle]="{
                          borderColor: corporateDesign.primaryBorderColor(),
                        }">
                        {{ getTransportName(leg) }}
                      </span>
                    }
                  </div>
                </div>
              }

              <div class="relative flex flex-row items-start gap-3">
                <div class="relative flex w-5 shrink-0 flex-col items-center">
                  <div
                    class="relative z-10 h-7 w-7 rounded-full border-3"
                    [ngStyle]="{
                      borderColor: corporateDesign.primaryColor(),
                      backgroundColor: corporateDesign.surface1(),
                    }"></div>
                </div>
                <div class="flex flex-col gap-0.5">
                  <div class="flex flex-row items-baseline gap-2">
                    <span class="mr-4 ml-2 text-base font-bold">{{
                      getFinalDestinationTime()
                    }}</span>
                    <span class="text-base font-medium">{{
                      trip().destination.name
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="relative flex h-10 items-center overflow-hidden"
            [ngStyle]="{ backgroundColor: corporateDesign.surface1() }">
            <div
              class="absolute top-1/2 left-0 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border border-l-0"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
                backgroundColor: corporateDesign.surface1(),
              }"></div>
            <div
              class="mx-5 flex-1 border-t-2 border-dashed"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
              }"></div>
            <div
              class="absolute top-1/2 right-0 h-10 w-10 translate-x-1/2 -translate-y-1/2 rounded-full border border-r-0"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
                backgroundColor: corporateDesign.surface1(),
              }"></div>
          </div>

          <div
            class="rounded-b-2xl border-r border-b border-l p-6"
            [ngStyle]="{
              borderColor: corporateDesign.primaryBorderColor(),
              backgroundColor: corporateDesign.surface1(),
              color: corporateDesign.isDarkModeActive()
                ? corporateDesign.corporateDesign().primaryDarkFontColor
                : corporateDesign.corporateDesign().colorAdmixtures
                    .standard_text_high,
            }">
            @if (validationError()) {
              <div
                class="mb-4 rounded-xl border p-4 text-sm"
                [ngStyle]="{
                  backgroundColor: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().colorAdmixtures
                        .error_red_dark + '20'
                    : corporateDesign.corporateDesign().colorAdmixtures
                        .error_red + '15',
                  borderColor: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().colorAdmixtures
                        .error_red_dark
                    : corporateDesign.corporateDesign().colorAdmixtures
                        .error_red,
                  color: corporateDesign.isDarkModeActive()
                    ? corporateDesign.corporateDesign().colorAdmixtures
                        .error_red_dark
                    : corporateDesign.corporateDesign().colorAdmixtures
                        .error_red,
                }">
                <span class="mb-1 flex items-center gap-1 font-bold">
                  <span class="material-symbols-rounded text-lg">error</span>
                  {{
                    textStore.texts()
                      | filterTexts
                        : ERelationType.attention
                        : EEntityType.onDemandTicketConfiguration
                      | language
                  }}
                </span>
                {{ validationError() }}
              </div>
            }

            <aw-button
              id="on-demand-reserve-btn"
              type="button"
              [style]="'error'"
              [isDisabled]="!allFormsValid"
              (click)="proceedToReservation()">
              {{
                textStore.texts()
                  | filterTexts
                    : ERelationType.checkVehicle
                    : EEntityType.onDemandTicketConfiguration
                  | language
              }}
            </aw-button>
          </div>
        </div>
      }
    </div>
  </div>
}
